/**
 * 督办 du
 */

import React, { useEffect, useState, useCallback, useRef } from "react";
import IconFont, { getIconFromString } from "@/components/icon";
import "./index.less";
import { queryNoRead } from "@/api/supervise";
import bus from "@/utils/bus";
import { useAppId } from "@/components/Supervise/envirment";
import { FocusSDK, isFocusEnv } from "@/utils";
import { Tooltip } from "antd";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { crossAppSwitch } from "@/utils/tools";
import { isLogin } from "@/utils/user";
import ThemeIcon, { ThemeType } from "@/layout/ThemeIcon";
import { connect } from "dva";
import { UserState } from "@/models/user";

function ExtendNavs({
  active,
  clickHandle,
  themes
}: {
  active: boolean;
  clickHandle: (path: string) => void;
  themes: ThemeType;
}) {
  const [readState, setReadState] = useState(false);
  const loadedUser = useRef<any>(null);
  const appId = useAppId();
  const getState = useCallback(() => {
    console.log("queryNoReadtest");
    queryNoRead()
      .then((res: any) => {
        const { readStatus } = res?.[0] || {};
        console.log("queryNoReadtest===", res);
        
        if (readStatus === "YES") {
          setReadState(true);
        } else {
          setReadState(false);
        }
      })
      .catch();
  }, [setReadState]);

  useEffect(() => {
    bus.addListener("supervise/update", getState);
    return () => {
      bus.removeListener("supervise/update", getState);
    };
  }, [getState]);

  const { appRuntimeEnv, focusSDK, authInfo } = React.useContext<GlobalContextConfig>(
    GlobalContext
  );
  useEffect(() => {
    if (!authInfo) {
      setReadState(false);
    }
    if (
      !authInfo ||
      (loadedUser.current?.userId === authInfo.userId &&
        loadedUser.current?.selectedTeamId === authInfo?.selectedTeamId)
    ) {
      return;
    }
    console.log("authInfochange1");
    loadedUser.current = authInfo;
    // 延迟 2s 执行，等待gatewayInstance初始化完成
    setTimeout(() => {
      getState();
    }, 2000)
    
  }, [authInfo]);
  const openUrl = useCallback(() => {
    let currentOrigin = FocusSDK.getMeMainEntry();
    let helpUrl = "";
    if (appRuntimeEnv.envConfig?.helpUrl) {
      helpUrl = appRuntimeEnv?.envConfig?.helpUrl;
    } else {
      helpUrl = `${currentOrigin}/guide/#/pc`;
      if (process.env.REACT_APP_NODE_ENV !== "production" && appRuntimeEnv.env !== "prod") {
        helpUrl = `${currentOrigin}/jingzhiban#/pc`;
      }
    }
    if (!isFocusEnv()) {
      helpUrl = `${helpUrl}?web=true`;
      window.open(helpUrl);
    } else {
      window.open(helpUrl);
    }
  }, [appRuntimeEnv.env, appRuntimeEnv.envConfig?.helpUrl]);
  // if (FocusSDK.getDeviceInfo().platform === 'web') {
  //     return null;
  // }

  return (
    <>
      {!!crossAppSwitch("supervise") && (
        <div
          role="button"
          tabIndex={0}
          onClick={() => {
            if (!isLogin(appRuntimeEnv)) {
              focusSDK.emit("showLogin", {
                type: "path",
                path: "/supervise"
              });
              return;
            }
            clickHandle("/supervise");
          }}
          className={`extend-nav-item ${active ? "active" : ""}`}
          clstag="pageclick|keycount|focus_home_01_1615797361152|6"
        >
          {readState ? <p className="eni-dot" /> : null}
          <div className={`focus-nav-item extend-nav-item_bg ${active ? "active" : ""}`}>
            <Tooltip placement="right" title="催办">
              <ThemeIcon name="Remind" theme={themes} active={active} />
            </Tooltip>
          </div>
        </div>
      )}
      {!!crossAppSwitch("help") && (
        <div role="button" onClick={openUrl} className="extend-nav-item">
          <Tooltip placement="right" title="帮助中心">
            <IconFont style={{ fontSize: 20 }} type="iconpc_butten_help_kjia" />
          </Tooltip>
        </div>
      )}
    </>
  );
}

function mapStateToProps({ user }: { user: UserState }) {
  const { themes } = user;

  return {
    themes
  };
}

export default connect(mapStateToProps)(ExtendNavs);
